import { useCallback } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'modules/domains/list';
import { BUTTON_SIZES, BUTTON_VARIANTS, IconButton } from 'ui/button';
import { FolderClosed } from 'ui/icons';
import { useModalContext } from 'utils/contexts/modal';
import { ListIndexModalState } from '../types';

const FolderButton = styled(IconButton)`
  width: min-content;
  white-space: nowrap;
`;

export const DATA_TEST_ID = 'new-list-folder-button';

export const NewFolderButton = () => {
  const { t } = useTranslation();
  const { showModal } = useModalContext<ListIndexModalState>();

  const onClick = useCallback(() => {
    showModal(ListIndexModalState.createFolder);
  }, [showModal]);

  return (
    <FolderButton
      data-test={DATA_TEST_ID}
      variant={BUTTON_VARIANTS.SECONDARY}
      size={BUTTON_SIZES.LARGE}
      onClick={onClick}
    >
      <FolderClosed />
      <span>{t('indexPage.button.newFolder')}</span>
    </FolderButton>
  );
};
